import React from 'react';
import './Spinner.css';

const Spinner = () => (
    <div className="container-loader">
        <div className="loader">Loading...</div>
    </div>
);

export default Spinner;